import PropTypes from "prop-types";
import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

function AgriPanel({ title, subtitle, actions, children, noPadding }) {
  return (
    <Card
      sx={{
        overflow: "hidden",
        border: "1px solid rgba(126, 170, 220, 0.12)",
        background: "linear-gradient(180deg, rgba(11,22,36,0.96) 0%, rgba(9,18,31,0.96) 100%)",
        boxShadow: "0 18px 40px rgba(0,0,0,0.24)",
      }}
    >
      {(title || subtitle || actions) && (
        <MDBox
          px={3}
          py={2.5}
          display="flex"
          alignItems={{ xs: "flex-start", md: "center" }}
          justifyContent="space-between"
          flexDirection={{ xs: "column", md: "row" }}
          gap={2}
          sx={{
            borderBottom: "1px solid rgba(126, 170, 220, 0.12)",
            background:
              "linear-gradient(135deg, rgba(17,35,56,0.96) 0%, rgba(13,29,47,0.9) 100%)",
          }}
        >
          <MDBox>
            {title ? (
              <MDTypography variant="h6" sx={{ color: "#edf4ff" }} fontWeight="bold">
                {title}
              </MDTypography>
            ) : null}
            {subtitle ? (
              <MDTypography
                variant="button"
                sx={{ mt: 0.4, display: "block", color: "#8fa7c4" }}
              >
                {subtitle}
              </MDTypography>
            ) : null}
          </MDBox>
          {actions ? <MDBox>{actions}</MDBox> : null}
        </MDBox>
      )}

      <MDBox p={noPadding ? 0 : 3}>{children}</MDBox>
    </Card>
  );
}

AgriPanel.defaultProps = {
  title: "",
  subtitle: "",
  actions: null,
  noPadding: false,
};

AgriPanel.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  actions: PropTypes.node,
  children: PropTypes.node.isRequired,
  noPadding: PropTypes.bool,
};

export default AgriPanel;
